import Switch from '@material-ui/core/Switch';
import React from "react";
import { useDispatch } from 'react-redux';
import { useSearch } from "hooks/useSearch";
import { selectTagStation } from 'redux/actions/unitsSection/unitsAction';

export const columnsTags = [
  {
    Header: 'Tag',
    accessor: 'label',
    filterable: true,
    filterMethod: (filter, row) => {
      return row.label.toLowerCase().includes(filter.value.toLowerCase())
    },
    style: {
      width: '100%',
    }
  },
  {
    Header: 'Acciones',
    Cell: (props) => {
      const {original} = props 
      const dispatch = useDispatch();
      const { setSnackbar } = useSearch();
      const counter = 0
      const handleChange = () => {

        counter < 6 
          ? dispatch(selectTagStation(original.id))
          : dispatch( setSnackbar('No se pueden agregar mas de 6 etiquetas', 'danger') )
      };

      return (
        <Switch
          id={original.id}
          color="primary"
          checked={original.select}
          name="select"
          style={{ float: 'right' }}
          onChange={handleChange}
        />
      );
    },
    style: {
      width: '20%',
      textAlign: 'right',
    },
  },
];
